<template>
  <div ref="chartPie" style="width:100%; height:100%;"></div>
</template>

<script>
import echarts from 'echarts';
export default {
  props:{
    options:{
      type:Object,
      default:()=>{}
    },
    config:{
      type:Object,
      default:()=>{}
    }
  },
  data(){
    return {
      chartPie:null
    }
  },
  watch:{
    options:{
      deep:true,
      handler(val){
        this.initChart();
      }
    }
  },
  mounted(){
    this.initChart();
    window.addEventListener('resize',()=>{
      if(this.chartPie){
        this.chartPie.resize()
      }
    }) ;
  },
  methods: {
    async initChart() {
      this.chartPie = echarts.init(this.$refs.chartPie,'mytheme');
      let option = {
        color:['#e39d62','#d26e68','#5e70f0','#aedcf9','#ff6600','#7d79c2'],
        tooltip: {
          show:this.config.tooltipShow,
          trigger: 'item',
          formatter:'{b}<br>{c}'+'%'
        },
        legend: {
          show:this.config.legend,
          itemHeight:8,
          itemWidth:8,
          orient: 'vertical',
          right:'right',
          top:'center',
          icon:'rect'
        },
        series: this.options.series,
      };

      this.chartPie.setOption(option)
    },
  },
  beforeDestroy() {
    if (!this.chartPie) {
      return;
    }
    this.chartPie.dispose();
    this.chartPie = null;
  },
};
</script>
